import React, { useState, useContext } from "react";
import { useFinalQuote } from "hooks/Quotes/useFinalQuote";
import DataProvider from "Context/DataContext";
import { useTailoredQuote } from "hooks/Forms/useTailoredQuote";
import Loader from "components/loader";
import SaveQuotePopUp from "./SaveQuotePopUp";
import { useForm } from "react-hook-form";
import ThankYouPopup from "components/popup/thankYouPopup";
import QuoteCard from "../firstComp/QuoteCard";

function SecondStep({ setStep, setSelected, setOpen }) {
  const { quoteId, stepsData, setStepsData, setThirdStepData } = useContext(DataProvider);

  const [tailoredBtn, setTailoredBtn] = useState("");
  const handleTailoredBtn = (e) => {
    setTailoredBtn(e.target.value);
  };

  const [thankOpen, setThankOpen] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const { status, mutateAsync } = useFinalQuote();
  const [serviceType, setServiceType] = useState(1);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const SERVICE_TYPE_BEST_PRICE = 1;
  const SERVICE_TYPE_BEST_TIME = 2;

  const OnSubmit = (params) => {
    const postData = {
      service_type: params,
      quote_id: quoteId,
    };
    mutateAsync(postData).then((data) => {
      setThirdStepData(data);
      setStepsData(data);
    });
    localStorage.setItem("step", 3);
    setStep("3");
    setSelected("3");
  };

  const { status: Status, mutateAsync: MutateAsyncronous } = useTailoredQuote();

  const SubmitSubscribe = (data) => {
    const postData = {
      email: data.email,
      quote_id: quoteId,
    };
    MutateAsyncronous(postData).then((response) => {
      reset();
      setThankOpen(true);
    });
  };

  return (
    <>
      <div className="flex items-center justify-center w-full ">
        <div className="mainContainer 2xl:w-9/12 xl:w-11/12  w-full mx-auto flex-col flex-wrap justify-center font-secondary 2xl:px-0 px-5 max-w-[1600px]">
          <p className="text-4xl font-semibold  text-center">Choose your Translation Solution</p>
          <div className="flex-col flex items-center justify-center w-full ">
            <div className="textDiv flex justify-center md:flex-nowrap flex-wrap py-6 text-center w-full items-start">
              <p className="text-base text-center font-opensans flex md:mb-0 mb-3">
                {" "}
                <span className="font-bold mr-1">Language Pair : </span>{" "}
                {stepsData?.data?.quote?.source_language ? stepsData?.data?.quote?.source_language : <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-28 ml-2"></div>}-
                {stepsData?.data?.quote_items?.map(({ target_language }) => (
                  <span>{target_language},</span>
                ))}{" "}
              </p>
              <p className=" text-center font-opensans ml-2 lg:ml-4 text-base flex items-center justify-between">
                <span className="font-bold whitespace-nowrap mr-1">Word Count :</span>{" "}
                {stepsData?.data?.quote?.total_words ? stepsData?.data?.quote?.total_words : <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-28 ml-2"></div>}
              </p>
            </div>
            <SaveQuotePopUp open={popUpOpen} setsOpen={setPopUpOpen} setOpen={setOpen} serviceType={serviceType} />
            {!stepsData?.data?.quote?.is_special && (
              <>
                <div className="cardsDiv grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-3 2xl:gap-x-4 w-full gap-y-7   py-6 ">
                  <div className="cardOne max-w-[450px] md:h-[444px] md:relative  border border-t border-b border-textgray text-center xl:px-8 xl:py-10 md:px-6 md:py-7 px-5 py-6 bg-white md:mb-0 mb-5">
                    <p className="text-3xl font-arial pb-4  font-semibold mt-5">Best Price</p>
                    <p className="pb-6  whitespace-normal">1 Year Guarantee | Professional Translators</p>
                    <p>Max Delivery Time</p>
                    <p className="pb-6 font-semibold font-arial text-2xl">
                      {stepsData?.data?.quote?.total_best_price_duration_in_words ? (
                        stepsData?.data?.quote?.total_best_price_duration_in_words
                      ) : (
                        <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-full"></div>
                      )}
                    </p>
                    <p className="text-4xl font-semibold font-arial">
                      {stepsData?.data?.quote?.best_price_amount ? stepsData?.data?.quote?.best_price_amount : <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-full"></div>}
                    </p>
                    <p className="pb-4 font-arial text-sm text-quotetext-500">
                      Price per word:&nbsp;
                      {stepsData?.data?.quote?.price_per_word_best_price ? (
                        stepsData?.data?.quote?.price_per_word_best_price
                      ) : (
                        <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-full"></div>
                      )}
                    </p>
                    <div className="md:absolute md:bottom-8  md:left-[50%] md:translate-x-[-50%]">
                      <button className="bg-orange text-white rounded-3xl md:px-28 px-16 py-2 font-semibold w-full flex justify-center items-center" onClick={() => OnSubmit(SERVICE_TYPE_BEST_PRICE)}>
                        Continue
                      </button>
                      <p
                        className="underline max-w-max text-center pt-2 mx-auto hover:text-orange font-arial text-sm cursor-pointer"
                        onClick={() => {
                          setServiceType(SERVICE_TYPE_BEST_PRICE);
                          setPopUpOpen(true);
                        }}
                      >
                        SAVE QUOTE
                      </p>
                    </div>
                  </div>
                  <div className="cardTwo max-w-[450px] md:h-[444px] md:relative  md:border-t md:border-b border border-textgray text-center xl:px-8 xl:py-10 md:px-6 md:py-7 px-5 py-6  bg-white md:mb-0 mb-5 relative">
                    <div className="recommendedCard"></div>
                    <p className="text-3xl font-arial pb-4 font-semibold mt-5">Fast Delivery</p>
                    <p className="pb-6  whitespace-normal">1 Year Guarantee | Professional Translators</p>
                    <p>Max Delivery Time</p>
                    <p className="pb-6 font-semibold text-2xl font-arial">
                      {stepsData?.data?.quote?.total_best_time_duration_in_words ? (
                        stepsData?.data?.quote?.total_best_time_duration_in_words
                      ) : (
                        <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-full"></div>
                      )}
                    </p>
                    <p className="text-4xl font-semibold font-arial">
                      {stepsData?.data?.quote?.best_time_amount ? stepsData?.data?.quote?.best_time_amount : <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-full"></div>}
                    </p>
                    <p className="pb-4 font-arial text-sm text-quotetext-500">
                      Price per word:{" "}
                      {stepsData?.data?.quote?.price_per_word_best_time ? (
                        stepsData?.data?.quote?.price_per_word_best_time
                      ) : (
                        <div class="h-5 bg-quotetext-100 animate-pulse rounded-md col-span-1 w-full"></div>
                      )}
                    </p>
                    <div className="md:absolute md:bottom-8  md:left-[50%] md:translate-x-[-50%]">
                      <button className="bg-orange text-white rounded-3xl md:px-28 px-16 py-2 font-semibold w-full flex justify-center items-center" onClick={() => OnSubmit(SERVICE_TYPE_BEST_TIME)}>
                        Continue
                      </button>
                      <p
                        className="underline max-w-max text-center pt-2 mx-auto hover:text-orange font-arial text-sm cursor-pointer"
                        onClick={() => {
                          setServiceType(SERVICE_TYPE_BEST_TIME);
                          setPopUpOpen(true);
                        }}
                      >
                        SAVE QUOTE
                      </p>
                    </div>
                  </div>
                  <form
                    className="cardThree max-w-[450px] md:h-[444px] md:relative border border-t border-b border-textgray text-center xl:px-8 xl:py-10 md:px-6 md:py-7 px-5 py-6  bg-white md:mb-0 mb-5"
                    onSubmit={handleSubmit(SubmitSubscribe)}
                  >
                    <p className="text-3xl font-arial pb-4 font-semibold mt-5">Tailored</p>
                    <p className="pb-6 leading-[30px] font-arail text-xl mt-3">A Tomedes expert will analyze your request and get back to you in a short time</p>
                    <input
                      className="h-[52px] w-full text-quotetext-200 border border-quotetext-100 rounded-lg px-5"
                      type="email"
                      name="email"
                      placeholder="Enter your email address here"
                      required
                      {...register("email", { required: true })}
                      onChange={handleTailoredBtn}
                      value={tailoredBtn}
                    />
                    <p className="text-left text-xs font-arial text-quotetext-200 mt-[2px] mb-1.5">*will only be used to contact you once</p>
                    {errors.email && <span className="text-xs font-opensans font-normal text-left w-full text-red">This field is required.</span>}
                    <div className="md:absolute md:bottom-8  md:left-[50%] md:translate-x-[-50%]">
                      {tailoredBtn.length > 0 ? (
                        <button
                          type="submit"
                          className={`
                bg-orange text-white rounded-3xl md:px-28 px-16 py-2 font-semibold w-full flex justify-center items-center`}
                        >
                          {Status === "loading" ? <Loader /> : "Continue"}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          disabled
                          className={`
bg-orange text-white rounded-3xl md:px-28 px-16 py-2 font-semibold w-full flex justify-center items-center opacity-30`}
                        >
                          {Status === "loading" ? <Loader /> : "Continue"}
                        </button>
                      )}

                      <p className="invisible underline max-w-max text-center pt-2 mx-auto hover:text-orange font-arial text-sm cursor-pointer">SAVE QUOTE</p>
                    </div>
                  </form>
                </div>
              </>
            )}

            {stepsData?.data?.quote?.is_special === 1 && (
              <>
                <div className="cardsDiv grid grid-cols-1 place-items-center md:w-11/12 w-full gap-y-7   py-6 ">
                  <form
                    className="cardThree max-w-[396px] border border-t border-b border-textgray text-center xl:px-8 xl:py-10 md:px-6 md:py-7 px-5 py-6  bg-white md:mb-0 mb-5"
                    onSubmit={handleSubmit(SubmitSubscribe)}
                  >
                    <p className="text-3xl font-arial pb-4 font-semibold">Special Offer</p>
                    <p className="pb-6 leading-[30px] font-arail text-xl mt-3">
                      We are now offering a special offer on this translation.
                      <br />A Tomedes expert will analyze your request and get back to you in a short time
                    </p>
                    <input
                      className="h-[52px] w-full text-quotetext-200 border border-quotetext-100 rounded-lg px-5"
                      type="email"
                      name="email"
                      placeholder="Enter your email address here"
                      required
                      {...register("email", { required: true })}
                    />
                    <p className="text-left text-xs font-arial text-quotetext-200 mt-[2px] mb-1.5">*will only be used to contact you once</p>
                    {errors.email && <span className="text-xs font-opensans font-normal text-left w-full text-red">This field is required.</span>}

                    <button
                      type="submit"
                      className={`
        bg-orange text-white rounded-3xl md:px-28 px-16 py-2 font-semibold w-full flex justify-center items-center`}
                    >
                      {Status === "loading" ? <Loader /> : "Continue"}
                    </button>
                  </form>
                </div>
              </>
            )}
          </div>
          <div className="divBackText flex">
            <p className="border-b text-quotetext-300 max-w-max pt-4 cursor-pointer text-lg font-opensans hover:text-orange mb-9">
              <span
                onClick={() => {
                  setSelected("1");
                  setStep("1");
                  localStorage.setItem("step", 1);
                }}
              >{`< Edit Project Details`}</span>{" "}
            </p>
          </div>
        </div>
        <ThankYouPopup open={thankOpen} setOpen={setThankOpen} setOpenPopUp={setOpen} />
      </div>
      <div className="w-full 2xl:w-[65%] xl:w-10/12  max-w-screen-2xl px-4 xl:px-0 sm:mt-5">
        <QuoteCard />
      </div>
    </>
  );
}

export default SecondStep;
